export function isPrivateProfilePath(pathname) {
  return /^\/(?:candidate-profiles|outreach-campaigns|business-campaigns)(?:\/|$)/.test(pathname || '')
}
export function filterPrivateProfileEvent(event, pathname) {
  return isPrivateProfilePath(pathname) ? null : event
}
